import validationPatterns from "../../../util/validationPatterns";
import _ from "lodash";

export const getDropDownInputText = (
  id,
  valueList,
  key = "id",
  value = "value"
) => {
  let filterValue = valueList  && valueList.length > 0  && valueList.filter((val) => val[key] == id);

  if (filterValue && _.isArray(filterValue) && filterValue.length > 0) {
    return (
      filterValue[0][key] +
      ((filterValue[0][value] && " - " + filterValue[0][value]) || "")
    );
  }

  return id;
};

export const checkIfValueIsPresentInDropdown = (value , packageCount) => {
  let errMsg =[] 
  if(value && value.length > 2){
    errMsg.push("Choose appropiate value from the dropdown")
  }
  if(value === ""){
    errMsg.push("Package Type is Mandatory")
  }
  if((packageCount==="0"||packageCount==="") && value !== "" && !["VG", "VQ", "VL", "VS", "VY", "VR", "VO"].includes(value)){
    errMsg.push("Package Count cannot be 0 or empty when Package Type is present")
  }
   return errMsg
}

export const canNeverBeZeroValidation = (field, value,type ) => {
  let errMsg = []
  let val =  value ? value.toString().trim() : ""
  let fieldDetails  =CanNeverBeZeroFields[type][field];
  if (fieldDetails && type ==="Missing" && fieldDetails.pattern.test(val)) {
    errMsg.push(
      fieldDetails.fieldName +" "+
        " is missing"
       
    );
  }
  if (fieldDetails  && type ==="Currency" && !fieldDetails.pattern.test(val)) {
    errMsg.push(
      fieldDetails.fieldName +" "+
        " can only be GBP"
       
    );
  }
  if (fieldDetails  && type ==="Money" && fieldDetails.pattern.test(val)) {
    errMsg.push(
      fieldDetails.fieldName +" "+
        "should be always greater than zero"
       
    );
  }
    if (fieldDetails  && type ==="NeverBeZero" && fieldDetails.pattern.test(val)) {
      errMsg.push(
        fieldDetails.fieldName + " "+
          "can never be zero"
         
      )
  }

  

  return errMsg
}


export const getPartiesValidationError = (field, value) => {
  let fieldDetails = fieldPatterns[field];
  let errors = [];
  if ((value.trim() === "" || value === " ") && !fieldDetails.optional) {
    errors.push(`${fieldDetails.fieldName} is mandatory`);
    return errors;
  }
  if (fieldDetails && (!fieldDetails.optional || value)) {
    if((field ==="consigneeeoriNumber")||(field ==="consignereoriNumber")){

      if(value.length <= 4){

        if (fieldDetails && !fieldDetails.pattern2.test(value)) {
          errors.push(
            fieldDetails.fieldName +
              " can only contain " +
              fieldDetails.description +
              " characters"
          );
        }
      }else{
        if (fieldDetails && (!fieldDetails.pattern.test(value) && !fieldDetails.pattern1.test(value) )) {
          errors.push(
            fieldDetails.fieldName +
              " can only contain " +
              fieldDetails.description +
              " characters"
          );
        }
      }

    }else{
      if (fieldDetails && !fieldDetails.pattern.test(value)) {
        errors.push(
          fieldDetails.fieldName +
            " can only contain " +
            fieldDetails.description +
            " characters"
        );
      }
    }
    if((field ==="consigneeeoriNumber")||(field ==="consignereoriNumber")){
      if(value.length === 4){
 
      }
      else{
    if (
      !(
        value.length >= fieldDetails.minLength &&
        value.length <= fieldDetails.maxLength
      )
    ) {
      let numberOdChars =
        fieldDetails.minLength === fieldDetails.maxLength
          ? fieldDetails.minLength
          : fieldDetails.minLength + " to " + fieldDetails.maxLength;

      errors.push(
        fieldDetails.fieldName +
          " should be " +
          numberOdChars +
          " characters long."
      );
    }
  }
}else{
      if (
        !(
          value.length >= fieldDetails.minLength &&
          value.length <= fieldDetails.maxLength
        )
      ) {
        let numberOdChars =
          fieldDetails.minLength === fieldDetails.maxLength
            ? fieldDetails.minLength
            : fieldDetails.minLength + " to " + fieldDetails.maxLength;
  
        errors.push(
          fieldDetails.fieldName +
            " should be " +
            numberOdChars +
            " characters long."
        );
      }
    }
  }
  return errors;
};

export const showNetMassGrossMaassValidation = (field1, value1 , field2, value2 ,) => {
  let fieldDetails1 = fieldPatterns[field1];
  let fieldDetails2= fieldPatterns[field2];
  let errors = [];
  if ((value1.trim() === "" || value1 === " ") && !fieldDetails1.optional) {
    errors.push(`${fieldDetails1.fieldName} is mandatory`);
    return errors;
  }
  if ((value2.trim() === "" || value2 === " ") && !fieldDetails2.optional) {
    errors.push(`${fieldDetails2.fieldName} is mandatory`);
    return errors;
  }
  if (fieldDetails1 && (!fieldDetails1.optional || value1)) {
    if (fieldDetails1 && !fieldDetails1.pattern.test(value1.trim())) {
      if (field1 === "eoriNumber") {
        errors.push(fieldDetails1.fieldName + " " + fieldDetails1.description);
      } else {
        errors.push(
          fieldDetails1.fieldName +
            " can only contain " +
            fieldDetails1.description +
            " characters"
        );
      }
    }
    if (
      !(
        value1.length >= fieldDetails1.minLength &&
        value1.length <= fieldDetails1.maxLength
      )
    ) {
      let numberOdChars =
        fieldDetails1.minLength === fieldDetails1.maxLength
          ? fieldDetails1.minLength
          : fieldDetails1.minLength + " to " + fieldDetails1.maxLength;

      errors.push(
        fieldDetails1.fieldName +
          " should be " +
          numberOdChars +
          " characters long."
      );
    }
  }

  if (fieldDetails2 && (!fieldDetails2.optional || value2)) {
    if (fieldDetails2 && !fieldDetails2.pattern.test(value2.trim())) {
      if (field2 === "eoriNumber") {
        errors.push(fieldDetails2.fieldName + " " + fieldDetails2.description);
      } else {
        errors.push(
          fieldDetails2.fieldName +
            " can only contain " +
            fieldDetails2.description +
            " characters"
        );
      }
    }
    if (
      !(
        value2.length >= fieldDetails2.minLength &&
        value2.length <= fieldDetails2.maxLength
      )
    ) {
      let numberOdChars =
        fieldDetails2.minLength === fieldDetails2.maxLength
          ? fieldDetails2.minLength
          : fieldDetails2.minLength + " to " + fieldDetails2.maxLength;

      errors.push(
        fieldDetails1.fieldName +
          " should be " +
          numberOdChars +
          " characters long."
      );
    }
  }

  if (
    (
      parseFloat(value1||0.00) <
      parseFloat(value2||0.00)
    )
  ) {


    errors.push(
      fieldDetails1.fieldName +
        " should be " +
       +
        " greater than" +  fieldDetails2.fieldName 
    )
  }
  
  return errors;
};

const fieldPatterns = {
  declarantFullName : {
    ...validationPatterns.P,
    optional : false,
    minLength: 1,
    maxLength: 35,
    fieldName : "Declarant Name"
}, 
  consigneeFullName : {
    ...validationPatterns.P,
    optional : false,
    minLength: 1,
    maxLength: 35,
    fieldName : " Name"
},
  consignerFullName : {
    ...validationPatterns.P,
    optional : false,
    minLength: 1,
    maxLength: 35,
    fieldName : "Name"
}, 
  declaranteoriNumber: {
    ...validationPatterns.eoriNumber,
    optional: false,
    minLength: 14,
    maxLength: 17,
    fieldName: "Eori Number",
  },
  consigneeeoriNumber: {
    ...validationPatterns.eoriNumber,
    optional: false,
    minLength: 14,
    maxLength: 17,
    fieldName: "Eori Number",
  },
  consignereoriNumber: {
    ...validationPatterns.eoriNumber,
    optional: false,
    minLength: 14,
    maxLength: 17,
    fieldName: "Eori Number",
  },
  consigneraddressLine1: {
    ...validationPatterns.P,
    optional: false,
    minLength: 0,
    maxLength: 70,
    fieldName: "Address Line 1",
  },
  consigneeaddressLine1: {
    ...validationPatterns.P,
    optional: false,
    minLength: 0,
    maxLength: 70,
    fieldName: "Address Line 1",
  },
  declarantaddressLine1: {
    ...validationPatterns.P,
    optional: false,
    minLength: 0,
    maxLength: 70,
    fieldName: "Address Line 1",
  },
  consignercity: {
    ...validationPatterns.CITY,
    optional: false,
    minLength: 0,
    maxLength: 35,
    fieldName: "City",
  },
  declarantcity: {
    ...validationPatterns.CITY,
    optional: false,
    minLength: 0,
    maxLength: 35,
    fieldName: "City",
  },
  consigneecity: {
    ...validationPatterns.CITY,
    optional: false,
    minLength: 0,
    maxLength: 35,
    fieldName: "City",
  },
  consigneezipcode: {
    ...validationPatterns.POSTAL_CODE,
    optional: false,
    minLength: 0,
    maxLength: 9,
    fieldName: "Postal Code",
  },
  consignerzipcode: {
    ...validationPatterns.POSTAL_CODE,
    optional: false,
    minLength: 0,
    maxLength: 9,
    fieldName: "Postal Code",
  },
  declarantzipcode: {
    ...validationPatterns.POSTAL_CODE,
    optional: false,
    minLength: 0,
    maxLength: 9,
    fieldName: "Postal Code",
  },
  consignercountry: {
    ...validationPatterns.P,
    optional: false,
    minLength: 2,
    maxLength: 2,
    fieldName: "Country",
  },
  consigneecountry: {
    ...validationPatterns.P,
    optional: false,
    minLength: 2,
    maxLength: 2,
    fieldName: "Country",
  },
  declarantcountry: {
    ...validationPatterns.P,
    optional: false,
    minLength: 2,
    maxLength: 2,
    fieldName: "Country",
  },
  grossMass: {
    ...validationPatterns.N11D7,
    optional: false, 
    minLength: 0,
    maxLength: 14,
    fieldName: "Gross Mass"
},
netMass: {
    ...validationPatterns.N11D7,
    optional: false, 
    minLength: 0,
    maxLength: 14,
    fieldName: "Net Mass"
},
packageCount: {
    ...validationPatterns.N,
    optional: false, 
    minLength: 0,
    maxLength: 5,
    fieldName: "Package count"
},
packageType: {
  ...validationPatterns.AN,
  optional: false, 
  minLength: 2,
  maxLength: 2,
  fieldName: "Package type"
},
};

const CanNeverBeZeroFields = {
  Missing:{
    grossMass: {
      ...validationPatterns.NeverBeZero,
      fieldName: "Gross Mass"
    },
    netMass: {
      ...validationPatterns.NeverBeZero,
      fieldName: "Net Mass"
    }
  }
,
Currency:{
  vatValueCurrency:{
    ...validationPatterns.gbp,
    fieldName: "Vat Value Currency"
  }
},
Money:{
  vatValueAmount:{
    ...validationPatterns.GreaterThanZero,
    fieldName: "Vat Value Amount"
  },

},
NeverBeZero : {
  grossMass: {
    ...validationPatterns.GreaterThanZero,
    fieldName: "Gross Mass"
  },
  netMass: {
    ...validationPatterns.GreaterThanZero,
    fieldName: "Net Mass"
  }
}
  
}
